<template>
  <div class="home">
    <!-- <ul class="btn">
      <li v-for="(item,i) in btn" :key="i" :class="btnactivelen==i?'btnactive':''" @click="btnClick(item,i)">{{item.name}}</li>
    </ul> -->
    <!-- <listquery class="listquery" @queryDatas="querydata"></listquery> -->

    <leftpage class="homel" v-if="btnactivelen==0" @lssx="lssx" :Nrssx="Nrssx"></leftpage>
    <rightpage class="homer" v-if="btnactivelen==0" @rssx="rssx" :Nlssx="Nlssx" style="width:500px"></rightpage>

    <Ldygc class="homel" v-if="btnactivelen==3" :gisclick="gisrightdata"></Ldygc>
    <Rdygc class="homer" v-if="btnactivelen==3" style="width:500px" :gisclick="gisrightdata"></Rdygc>
  </div>
</template>

<script>
  import leftpage from "./leftPage.vue";
  import rightpage from "./rightPage.vue";
  import Ldygc from "./Ldygc.vue";
  import Rdygc from "./Rdygc.vue";
  import listquery from "@/components/visualization/LlistQuery.vue";

  export default {
    props: ["gisClick", "map", "querydatas"],
    data() {
      return {
        btnactivelen: 0,
        gisrightdata: null,
        Nlssx: null,
        Nrssx: null,
      };
    },
    components: {
      leftpage,
      rightpage,
      Ldygc,
      Rdygc,
      listquery,
    },
    mounted() {},
    computed: {
      fanhuiStatus() {
        return this.$store.state.fanhuiShow; //需要监听的数据
      },
    },
    watch: {
      gisClick: {
        handler(newVal, oldVal) {
          let _this = this;
          if (newVal != null) {
            this.btnactivelen = 3;
            setTimeout(function() {
              _this.gisrightdata = newVal;
            }, 200);
          }
        },
        immediate: true,
        deep: true,
      },
      querydatas(data, data1) {
        let _this = this;
        if (data.children.length == 0) {
          this.btnactivelen = 3;
          this.$store.commit('fanhuiFun', false); //token
          this.map.setView([Number(data.ydbWeiDu), Number(data.ydbJingDu)], 15);
          setTimeout(function() {
            _this.gisrightdata = data;
          }, 200);
          // this.gisrightdata = data;
        } else if (data.children[0] == 0) {
          this.btnactivelen = 0;
          this.$store.commit('fanhuiFun', true); //token
        } else {
          setTimeout(function() {
            _this.gisrightdata = data;
          }, 200);
          this.btnactivelen = 0;
          this.$store.commit('fanhuiFun', false); //token
        }
      },
      fanhuiStatus(newVal, oldVal) {
        // console.log('---->返回--',newVal)
        if (newVal == true) {
          this.btnactivelen = 0;
          this.gisrightdata = null;
        }
      },
    },
    methods: {
      btnClick(item, i) {
        this.btnactivelen = i;
      },
      // querydata(data) {
      //   let _this = this;
      //   if (data.children.length == 0) {
      //     this.btnactivelen = 3;
      //     this.$store.commit("fanhuiFun", false); //token
      //     this.map.setView([Number(data.ydbWeiDu), Number(data.ydbJingDu)], 15);
      //     setTimeout(function() {
      //       _this.gisrightdata = data;
      //     }, 200);
      //   } else if (data.children[0] == 0) {
      //     this.btnactivelen = 0;
      //     this.$store.commit('fanhuiFun', true); //token
      //   } else {
      //     setTimeout(function() {
      //       _this.gisrightdata = data;
      //     }, 200);
      //     this.btnactivelen = 0;
      //     this.$store.commit('fanhuiFun', false); //token
      //   }
      // },
      lssx(data) {
        this.Nlssx = data;
      },
      rssx(data) {
        this.Nrssx = data;
      },
    },
  };
</script>

<style scoped="scoped">
  .home {
    position: fixed;
    z-index: 1;
    height: 100%;
  }

  .homel,
  .homer {
    width: 360px;
    position: fixed;
    z-index: 100;
    top: 130px;
    overflow: auto;
    background: transparent;
    bottom: 30px;
  }

  .homel {
    left: 10px;
  }

  .homer {
    right: 10px;
  }
</style>
